import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { Provider } from "react-redux";
import store from "./redux/reducer/store.js";
import { Toaster } from "react-hot-toast";
import InstallPrompt from "./utils/InstallPrompt.js";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Toaster />
      <div className="relative float-right w-full !bg-white dark:!bg-navy-900">
        {/* <InstallPrompt /> */}
      </div>
      <App />
    </Provider>
  </BrowserRouter>
);
